import { call, put, takeLatest } from "redux-saga/effects";

import { getAPIPayload } from "../../../apis/getApi";
import { postAPIPayload } from "../../../apis/postApi";
import { agentsAdminAction } from "../../slices/brokers/agentAdminSlice";

export function* fetchAgentsAdmninDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(
    agentsAdminAction.fetchAgentAdminData({
      ...response,
      all_salesManager: payload?.all_salesManager,
      is_superAdmin: payload?.token,
    })
  );
}

export function* fetchAdmninProfileDataSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchAdminProfileData(response));
}

export function* fetchAgentsDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchAgentsData(response));
}

export function* fetchAgentsOfficeDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(
    agentsAdminAction.fetchAgentOfficeData({
      ...response,
      all_offices: payload?.all_offices,
      is_superAdmin: payload?.token,
    })
  );
}

export function* fetchCreateAgentsAdminDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchCreateAgentAdminData(response));
}

export function* fetchCreateAgentsOfficeDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchCreateAgentOfficeData(response));
}

export function* fetchUpdateAgentStatusDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchUpdateAgentStatusData(response));
}

export function* fetchSubscriptionHistoryDataSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchSubscriptionHistoryData(response));
}

export function* fetchAddSaveCardsDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchAddSaveCardsData(response));
}

export function* fetchSalesRepresentativeDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchSalesRepresentativeData(response));
}

export function* fetchUserContactDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchUserContactData(response));
}

export function* fetchUpdateCompanyDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);

  // set reponse data in store
  yield put(agentsAdminAction.fetchUpdateCompanyDetailsData(response));
}

export function* watchAgentsAdminSagaAsync() {
  yield takeLatest(
    agentsAdminAction.getAgentAdminDetails,
    fetchAgentsAdmninDataSaga
  );
  yield takeLatest(
    agentsAdminAction.getAdminProfileData,
    fetchAdmninProfileDataSaga
  );
  yield takeLatest(agentsAdminAction.getAgentsDetails, fetchAgentsDataSaga);
  yield takeLatest(
    agentsAdminAction.getAgentOfficeDetails,
    fetchAgentsOfficeDataSaga
  );
  yield takeLatest(
    agentsAdminAction.createAgentAdminDetails,
    fetchCreateAgentsAdminDataSaga
  );
  yield takeLatest(
    agentsAdminAction.createAgentOfficeDetails,
    fetchCreateAgentsOfficeDataSaga
  );
  yield takeLatest(
    agentsAdminAction.updateAgentStatusData,
    fetchUpdateAgentStatusDataSaga
  );
  yield takeLatest(
    agentsAdminAction.getSubscriptionHistoryDetails,
    fetchSubscriptionHistoryDataSaga
  );
  yield takeLatest(
    agentsAdminAction.getAddSaveCardsDetails,
    fetchAddSaveCardsDataSaga
  );
  yield takeLatest(
    agentsAdminAction.getSalesRepresentativeDetails,
    fetchSalesRepresentativeDataSaga
  );
  yield takeLatest(
    agentsAdminAction.getUserContactDetails,
    fetchUserContactDataSaga
  );
  yield takeLatest(
    agentsAdminAction.updateCompanyDetails,
    fetchUpdateCompanyDataSaga
  );
}
